import { DialogTitle } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { EmployeeDialogContent } from '~/components/EmployeeDialogContent';
import { useGetPublicProfile } from '~/services/Http/hooks';

export interface Props {
  employeeId: number;
}

export const PublicEmployeeDialogContent: React.FC<Props> = ({
  employeeId,
}) => {
  const { t } = useTranslation();

  const getPublicProfileReqParams = useMemo(
    () => ({
      employeeId: employeeId.toString(),
    }),
    [employeeId],
  );
  const {
    loading,
    failedToLoad,
    data: employeeInfo,
  } = useGetPublicProfile(getPublicProfileReqParams);

  return (
    <div data-cy="public-employee-dialog-content">
      <DialogTitle>{t('employeeInfo')}</DialogTitle>
      <AsyncContent isLoading={loading} failedToLoad={failedToLoad}>
        {employeeInfo && <EmployeeDialogContent employee={employeeInfo} />}
      </AsyncContent>
    </div>
  );
};
